import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { getPartnerApisHeaders } from './partnerApisHeaders';
const getAttributes = () => [{
  name: 'APP_VERSION'
}];
const getRequestBody = options => {
  return {
    dateRange: {
      startDate: options.startDate,
      endDate: options.endDate
    },
    granularity: options.granularity,
    attributes: getAttributes(),
    metrics: {
      metricFields: [{
        name: 'DOWNLOAD_COUNT'
      }]
    },
    attributesFilter: {
      expr: {
        andGroup: [{
          filter: {
            fieldName: 'APP_KEY',
            oneFilter: {
              stringFilter: {
                value: options.appKey
              }
            }
          }
        }]
      }
    },
    sortByList: [{
      name: 'DATE',
      order: 'asc'
    }, {
      name: 'APP_VERSION',
      order: 'desc'
    }]
  };
};
export const getDownloadsData = (mpacBaseUrl, options) => {
  return fetchOk("".concat(mpacBaseUrl, "/rest/2/vendors/").concat(options.partnerId, "/partner-metrics?limit=180"), {
    method: 'POST',
    body: JSON.stringify(getRequestBody(options)),
    headers: _objectSpread({
      'Content-Type': 'application/json;charset=UTF-8',
      credentials: 'same-origin'
    }, getPartnerApisHeaders())
  }).then(response => response.json());
};